import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTeams = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.567 7.2C12.0029 7.2 13.167 6.03594 13.167 4.6C13.167 3.16406 12.0029 2 10.567 2C9.13104 2 7.96698 3.16406 7.96698 4.6C7.96698 4.95436 8.03788 5.29216 8.16625 5.6H1.90019C1.49526 5.6 1.16699 5.92827 1.16699 6.33319V13.6668C1.16699 14.0717 1.49525 14.4 1.90019 14.4H6.05753C6.47008 16.4123 8.22628 17.9476 10.367 18C12.1608 17.9561 13.6846 16.8709 14.3741 15.3364C14.7342 15.5055 15.1364 15.6001 15.5606 15.6H15.5738C17.1164 15.6 18.367 14.3494 18.367 12.8068V8.75999C18.367 8.34026 18.0267 8 17.607 8H14.0338H13.1642H9.96698V7.13043C10.1596 7.17593 10.3605 7.2 10.567 7.2ZM17.967 5.4C17.967 6.39411 17.1611 7.2 16.167 7.2C15.1729 7.2 14.367 6.39411 14.367 5.4C14.367 4.40588 15.1729 3.6 16.167 3.6C17.1611 3.6 17.967 4.40588 17.967 5.4ZM6.03059 8.3912H7.49659V7.6168H3.63739V8.3912H5.09659V12.3832H6.03059V8.3912Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	})
});
export default SvgTeams;
